import { render, staticRenderFns } from "./PXCreateSurveyPage.vue?vue&type=template&id=00ee7146&scoped=true"
import script from "./PXCreateSurveyPage.vue?vue&type=script&lang=js"
export * from "./PXCreateSurveyPage.vue?vue&type=script&lang=js"
import style0 from "./PXCreateSurveyPage.vue?vue&type=style&index=0&id=00ee7146&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ee7146",
  null
  
)

export default component.exports